import { useState, useEffect } from "react";
import { getCarrouselCategory } from "../../services/getCarrouselCategory";
import WidgetContainer from "../reusablesComponents/containerWidget";
import Carrousel from "../reusablesComponents/carrousel";
import "./carrouselCategory.sass";

/**
 * Muestra un carrusel de categorías con una sección izquierda (logo + título) 
 * y una sección derecha (elementos de esa categoría).
 */
export default function CarrouselCategory({id, version }) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const type= "league"

  /**
   * Obtiene los datos del carrusel desde el servicio.
  */
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const result = await getCarrouselCategory({ id , type, version});
        setData(result.statusCode === 200 ? result.data : []);
      } catch (err) {
        console.error("Error al obtener datos:", err);
        setData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  return (
    <WidgetContainer loading={loading} heightLoading="" className="container__carrousel-category" id="container__carrousel-category">
      <div className="carrousel-category__component">
        {/* <LeftCarrouselCategory data={data[0]} loading={loading} /> */}
        <Carrousel
          data={data}
          cardWidth={130}
          loading={loading}
          classPrefix={"carrousel-category"}
          classCarrousel={"box-carrousel"}
          type="category"
        />
      </div>
    </WidgetContainer>
  )
}